import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiErrorMessage, isAdminRole, useLogin } from '../lib/api'
import { useAdminAuth } from '../lib/auth'

export function AdminLoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [roleError, setRoleError] = useState<string | null>(null)
  const login = useLogin()
  const auth = useAdminAuth()
  const nav = useNavigate()

  const submit = (e: FormEvent) => {
    e.preventDefault()
    setRoleError(null)
    login.mutate(
      { email, password },
      {
        onSuccess: async (resp) => {
          if (!isAdminRole(resp.user.role)) {
            setRoleError(`No admin privileges (${resp.user.role}).`)
            return
          }
          await auth.refresh()
          nav('/overview', { replace: true })
        },
      },
    )
  }

  return (
    <div className="auth-shell">
      <header className="auth-shell__topbar">
        <a href="/" className="auth-shell__logo">
          <img src="/assets/img/wordmark-light.svg" alt="Rival Prop Firm" className="auth-shell__logo--light" />
          <img src="/assets/img/wordmark-dark.svg"  alt="Rival Prop Firm" className="auth-shell__logo--dark" />
        </a>
        <span className="admin-mode-pill">
          <span className="admin-mode-pill__dot" aria-hidden="true"></span>
          Admin mode
        </span>
      </header>

      <main className="auth-shell__main">
        <div className="auth-card">
          <div className="auth-card__header">
            <h1 className="auth-card__title">Admin sign in</h1>
            <p className="auth-card__subtitle">Authorized personnel only.</p>
          </div>

          <form className="auth-card__body" onSubmit={submit} noValidate>
            <div className="field">
              <label className="field__label" htmlFor="admin-email">Email address</label>
              <input
                id="admin-email"
                className="field__input"
                type="email"
                required
                autoComplete="email"
                placeholder="you@rivalprop.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="field">
              <label className="field__label" htmlFor="admin-pw">Password</label>
              <input
                id="admin-pw"
                className="field__input"
                type="password"
                required
                autoComplete="current-password"
                placeholder="Your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {(login.isError || roleError) && (
              <div className="auth-card__error" role="alert" style={{ display: 'flex' }}>
                {roleError ?? apiErrorMessage(login.error)}
              </div>
            )}

            <button
              type="submit"
              className="btn btn--primary auth-card__submit"
              disabled={login.isPending}
            >
              {login.isPending ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </main>

      <footer className="auth-shell__footer">
        <span>© 2026 Rival Prop Firm · Admin</span>
      </footer>
    </div>
  )
}
